import Vue from "vue";
import Router from "vue-router";
import Welcome from "./components/Welcome";
import Introduction from "./components/user/Introduction";
import NewApp from "./components/applications/newApp";
import EditApp from "./components/applications/editApp";
import Application from "./components/applications/application";
import Applications from "./components/applications";
import Login from "./components/user/Login";
import CreateAccount from "./components/user/CreateAccount";
import ResetPassword from "./components/user/ResetPassword";
import AppSubmitted from "./components/applications/appSubmitted";

import { store } from "./store";

Vue.use(Router);

let router = new Router({
	routes: [
		{
			path: "/",
			name: "welcome",
			component: Welcome
		},
		{
			path: "/intro",
			name: "intro",
			component: Introduction
		},
		{
			path: "/login",
			name: "login",
			component: Login
		},
		{
			path: "/create-account",
			name: "createAccount",
			component: CreateAccount
		},
		{
			path: "/applications",
			name: "applications",
			component: Applications,
			beforeEnter(to, from, next) {
				checkUser(next, ["authed"]);
			}
		},
		{
			path: "/app",
			name: "startApp",
			component: Application,
			beforeEnter(to, from, next) {
				checkUser(next, ["authed", "guest"]);
			}
		},
		{
			path: "/new-app",
			name: "newApp",
			component: NewApp,
			beforeEnter(to, from, next) {
				checkUser(next, ["authed", "guest"]);
			}
		},
		{
			path: "/edit-app",
			name: "editApp",
			component: EditApp,
			beforeEnter(to, from, next) {
				checkUser(next, ["authed"]);
			}
		},
		{
			path: "/app-submitted",
			name: "appSubmitted",
			component: AppSubmitted,
			beforeEnter(to, from, next) {
				checkUser(next, ["authed", "guest"]);
			}
		},
		{
			path: "/reset-password/:route_email/:route_token",
			name: "resetPassword",
			component: ResetPassword,
			props: true
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

router.beforeEach((to, from, next) => {
	if (to.name !== "welcome") {
		store.dispatch("set_user_from_server");
	}

	next();
});

function checkUser(next, expectedUserType) {
	if (expectedUserType.indexOf(store.getters.userType) === -1) {
		next("/intro");
	}
	next();
}

export default router;
